import CheckCircle from '@mui/icons-material/CheckCircle';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CheckCircleIcon(props: FixMe) {
  return <CheckCircle {...props} />;
}

export default CheckCircleIcon;
